<template>
  <div class="gallery">
    <v-carousel v-model="currentSlide" :show-arrows="'hover'" hide-delimiters>
      <!-- <template v-slot:prev="{ props }">
        <v-btn
          icon="mdi-chevron-right"
          class="btn-right"
          variant="elevated"
          @click="props.onClick"
        ></v-btn>
      </template>
      <template v-slot:next="{ props }">
        <v-btn
          icon="mdi-chevron-left"
          class="btn-left"
          variant="elevated"
          @click="props.onClick"
        ></v-btn>
      </template> -->
      <v-carousel-item
        v-for="(image, index) in images"
        :key="index"
        :src="imageUrl(image)"
        contain
      ></v-carousel-item>
    </v-carousel>
    <div class="thumbnails">
      <img
        v-for="(image, index) in images"
        :key="index"
        :src="imageUrl(image)"
        alt="Thumbnail"
        @click="goToSlide(index)"
        class="thumbnail"
        :class="{ active: currentSlide === index }"
      />
    </div>
    <div class="gradient left" />
    <div class="gradient right" />
  </div>
</template>

<script>
import config from "../../config";
export default {
  data() {
    return {
      currentSlide: 1,
    };
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    mainImage: {
      type: Number,
      required: false,
    },
  },
  mounted() {
    this.currentSlide = this.mainImage;
  },
  methods: {
    imageUrl(image) {
      // check if the image is url
      if (image && image?.startsWith("http")) {
        return image;
      } else {
        return `${config.baseURL}${image}`;
      }
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
  },
};
</script>
<style lang="scss">
.btn-left,
.btn-right {
  background: #ffffff69;
  box-shadow: unset !important;
}
.btn-right {
  left: 10px;
}
.btn-left {
  right: 10px;
}
.gradient {
  position: absolute;
  height: 60px;
  width: 60px;
  bottom: 0px;
  &.left {
    background-image: linear-gradient(270deg, #ff000000, #ffffff);
    left: 0px;
  }
  &.right {
    background-image: linear-gradient(90deg, #ff000000, #ffffff);
    right: 0px;
  }
}
.thumbnails {
  display: flex;
  justify-content: center;
  overflow-x: scroll;
  margin-top: 10px;
  &::-webkit-scrollbar {
    display: none;
  }
}
.thumbnail {
  width: 60px;
  height: 60px;
  margin: 0 5px;
  cursor: pointer;
  object-fit: cover;
  &.active {
    border: 2px solid $primaryColor;
  }
}
</style>
